import cx from 'classnames'
import { FocusModeHidden } from 'components/FocusModeHidden/FocusModeHidden'
import { PropsWithChildren } from 'react'
import Styles from './Header.module.scss'
import { useHeaderTheme } from 'hooks/useHeaderTheme'

type Props = PropsWithChildren<{
  'data-testid'?: string
  className?: string
}>

export const Header = ({ children, className, ...rest }: Props) => {
  const theme = useHeaderTheme()

  return (
    <FocusModeHidden className={cx(Styles.root, className)} data-theme={theme} {...rest}>
      {children}
    </FocusModeHidden>
  )
}
